import { useLocation } from './locationContext';
import { AuditLogsList } from '../../../audit-log/components/AuditLogsList';

export const LocationAuditLogsPage = () => {
  const { location } = useLocation();

  return <AuditLogsList filter={{ locationId: location.id }} />;
};
